import { TABLE_COLUMN_VIEWS_ENDPOINT } from "@finway-group/shared/lib/consts/api.const"
import { type TableColumnView } from "@finway-group/shared/lib/models/tableColumnView/tableColumnView.interface"
import { type TableColumnViewTablesEnum } from "@finway-group/shared/lib/models/tableColumnView/tableColumnViewTables.enum"
import axios from "axios"

export const TableColumnViewService = {
    getView: async (table: TableColumnViewTablesEnum, { signal }: { signal?: AbortSignal } = {}) => {
        const { data } = await axios.get<TableColumnView>(`${TABLE_COLUMN_VIEWS_ENDPOINT}/${table}`, { signal })
        if (!data?.visibleColumns?.length || !data?.columnOrder?.length) {
            return undefined
        }
        return data
    },
    saveView: async (table: TableColumnViewTablesEnum, columns: TableColumnView) => {
        const { data } = await axios.put<TableColumnView>(`${TABLE_COLUMN_VIEWS_ENDPOINT}/${table}`, { columns })
        return data
    },
}
